import { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Creates Relay Context for child components
 */
export class RelayContextProvider extends Component {
    getChildContext() {
        return {
            relay: {
                environment: this.props.environment,
                variables: this.props.variables,
            },
        };
    }
    render() {
        const { render } = this.props;
        return render();
    }
}

RelayContextProvider.childContextTypes = {
    relay: PropTypes.object.isRequired,
};

RelayContextProvider.propTypes = {
    environment: PropTypes.object.isRequired,
    variables: PropTypes.object.isRequired,
    render: PropTypes.func.isRequired,
};
